import styled, {keyframes} from "styled-components";

type ColorProps = { color: string };
type BackgroundProps = { background: string };
type BorderProps = { borderColor: string };

const fadeSlideIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(-4px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

export const PanelContainer = styled.div<BackgroundProps & BorderProps>`
    background: ${props => props.background};
    border: 1px solid ${props => props.borderColor};
    border-radius: 12px;
    padding: 20px 24px;
    margin: 4px 0 8px;
    animation: ${fadeSlideIn} 0.22s ease;
`;

export const PanelHeader = styled.div`
    margin-bottom: 16px;
`;

export const PanelTitle = styled.span<ColorProps>`
    display: block;
    font-size: 11px;
    font-weight: 700;
    color: ${props => props.color};
    letter-spacing: 0.8px;
    text-transform: uppercase;
`;

export const PanelSubtitle = styled.span<ColorProps>`
    display: block;
    font-size: 12px;
    color: ${props => props.color};
    margin-top: 3px;
`;

export const TableWrapper = styled.div<BorderProps>`
    border: 1px solid ${props => props.borderColor};
    border-radius: 8px;
    overflow: hidden;
`;

export const InvoiceTable = styled.table`
    width: 100%;
    border-collapse: collapse;
`;

export const TableHead = styled.thead``;

export const TableBody = styled.tbody``;

export const TableHeaderRow = styled.tr<BackgroundProps & BorderProps>`
    background: ${props => props.background};
    border-bottom: 1px solid ${props => props.borderColor};
`;

export const TableHeaderCell = styled.th<ColorProps>`
    padding: 8px 12px;
    font-size: 11px;
    font-weight: 700;
    color: ${props => props.color};
    text-align: left;
    letter-spacing: 0.6px;
    text-transform: uppercase;

    &:last-child {
        text-align: right;
    }
`;

export const Divider = styled.div<BorderProps>`
    height: 1px;
    background: ${props => props.borderColor};
    margin: 16px 0;
`;

export const FooterRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;

export const FooterLabel = styled.span<ColorProps>`
    font-size: 13px;
    font-weight: 500;
    color: ${props => props.color};
`;

export const FooterValue = styled.span<ColorProps>`
    font-size: 16px;
    font-weight: 700;
    color: ${props => props.color};
`;
